import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Skeleton,
  Typography,
} from "@mui/material";

const TERMITE_FIELD_NAMES = ["protection_by", "treatment_method"];

const RenderTermite = ({ full_title, termite, onChange, fields }) => {
  const hasValidatedOnce = useRef(false);

  const savedProjects = useSelector((state) => state.nocData?.saved_projects);

  const { createDocLoading, addingNewTermite } = useSelector(
    (state) => state.buildingState,
  );

  const [termiteList, setTermiteList] = useState([]);
  const [loadingData, setLoadingData] = useState(true);

  useEffect(() => {
    setTermiteList(savedProjects?.termite || []);
    setLoadingData(false);
  }, [savedProjects?.termite]);

  useEffect(() => {
    // Run only if we haven't validated AND termiteList has loaded
    if (!hasValidatedOnce.current && termiteList.length > 0 && termite) {
      const selectedId = termite?.value;
      const selected = termiteList.find((pro) => pro.id === selectedId);

      if (!selected) {
        onChange("termite", "");
        TERMITE_FIELD_NAMES.forEach((name) => onChange(name, ""));
      }

      hasValidatedOnce.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [termiteList, termite]);

  const handleSelectChange = (event) => {
    const selectedId = event.target.value;
    const selected = termiteList.find((p) => p.id === selectedId);

    onChange("termite", {
      value: selectedId,
      label: selected?.["protection_by"],
    });
    TERMITE_FIELD_NAMES.forEach((name) =>
      onChange(name, selected?.[name] || ""),
    );
  };

  if (loadingData) {
    return <Skeleton variant="rectangular" height={120} />;
  }

  return (
    <>
      <Typography align="center" mt={2} mb={0} variant="h6">
        {full_title}
      </Typography>

      <FormControl
        fullWidth
        margin="normal"
        variant="filled"
        sx={{
          "& .MuiFilledInput-root": {
            border: termite ? "2px solid #004976" : undefined, // adjust thickness and color
            borderRadius: "14px",
            backgroundColor: "transparent", // optional
          },
          "& .MuiFilledInput-underline:before": {
            borderBottom: "none", // remove default bottom border
          },
          "& .MuiFilledInput-underline:after": {
            borderBottom: "none",
          },
        }}
      >
        <InputLabel>Termite Protection By</InputLabel>
        <Select
          disabled={createDocLoading || addingNewTermite}
          name="termite"
          value={termite?.value || ""}
          onChange={handleSelectChange}
          MenuProps={{
            PaperProps: {
              style: {
                marginTop: "1.5px",
                maxHeight: 200,
                width: "auto",
                maxWidth: "100%",
              },
            },
          }}
        >
          <MenuItem disabled value="">
            {termiteList.length === 0 ? "No records found" : "Select One"}
          </MenuItem>
          {termiteList?.map((option, i) => (
            <MenuItem key={option.id + i} value={option.id}>
              {option.protection_by || "Unnamed"}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default RenderTermite;
